export type RequestState = {
  [name in RequestEnum]: RequestData;
};

export interface RequestData {
  loading: boolean;
  error: string;
}

export enum RequestEnum {
  //deal actions
  getDeal = "getDeal",
  getDealLogo = "getDealLogo",
  getDealFile = "getDealFile",
  getDealCommitment = "getDealCommitment",
  setInvestment = "setInvestment",
  registerWebinar = "registerWebinar",
  registerWebinarQuestion = "registerWebinarQuestion",
  getDealReferralLink = "getDealReferralLink",
  downloadDealBackground = "downloadDealBackground",
  //auth actions
  refreshToken = "refreshToken",
  signIn = "signIn",
  getInvestorAccount = "getInvestorAccount",
  logout = "logout",
  //legal entity
  getLegalEntity = "getLegalEntity",
}
